import { z } from "zod";
import { PublicAppError } from "../lib/errors";

/** HTTPS em qualquer ambiente publicado; HTTP só para loopback de desenvolvimento. */
const workerUrlSchema = z
  .string()
  .url()
  .refine(
    (value) =>
      value.startsWith("https://") ||
      value.startsWith("http://127.0.0.1") ||
      value.startsWith("http://localhost"),
    "URL do Worker precisa ser HTTPS fora do loopback",
  );

export function workerBaseUrl(): string {
  const parsed = workerUrlSchema.safeParse(import.meta.env.VITE_WORKER_URL);
  if (!parsed.success) {
    throw new PublicAppError(
      "missing_public_config",
      "A configuração pública do assistente não está disponível.",
    );
  }
  return parsed.data.replace(/\/+$/, "");
}

export function workerEndpoint(path: string): string {
  return `${workerBaseUrl()}${path}`;
}
